// @ts-nocheck

const ICON_B2C = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="2.5 4.5 15 11" stroke="currentColor"><path d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path fill-rule="evenodd" d="M8 4.5a5.5 5.5 0 1 0 0 11h4a5.5 5.5 0 1 0 0-11h-4Zm-4 5.5a4 4 0 0 1 4-4h4a4 4 0 0 1 0 8h-4a4 4 0 0 1-4-4Z"></path></svg>';
const ICON_B2B = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="2.5 4.5 15 11" stroke="currentColor"><path d="M8 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path fill-rule="evenodd" d="M8 4.5a5.5 5.5 0 1 0 0 11h4a5.5 5.5 0 1 0 0-11h-4Zm-4 5.5a4 4 0 0 1 4-4h4a4 4 0 0 1 0 8h-4a4 4 0 0 1-4-4Z"></path></svg>';

window.VAT_CONFIG = {
  displayPopup:   true,
  defaultPricing: 'b2c',
  cookieDays:     364,
  taxRate:        25, // percentage applied on top of B2B (ex-VAT) price
  translations: {
    sv: {
      b2bButton: 'Företag',
      b2bHelper: 'exkl. moms',
      b2cButton: 'Privatperson',
      b2cHelper: 'inkl. moms',
    },
  },
};

// ── Utilities ─────────────────────────────────────────────────────────────────

// Shopify prices are stored in cents (öre). Format as "1 250 kr".
function formatSEK(cents) {
  return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
}

function getCookie(name) {
  return document.cookie.split('; ').find(r => r.startsWith(name + '='))?.split('=')[1] ?? null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getTranslations() {
  const lang = document.documentElement.lang;
  return window.VAT_CONFIG.translations[lang] ?? Object.values(window.VAT_CONFIG.translations)[0];
}

// ── Pricing format ────────────────────────────────────────────────────────────
// window.pricingFormat is the single source of truth: 'b2b' | 'b2c' | null

function setPricingFormat(format) {
  window.pricingFormat = format;
  setCookie('pricingFormat', format, window.VAT_CONFIG.cookieDays);
  document.querySelector('.vat-selector-popup')?.style.setProperty('display', 'none');
  window.dispatchEvent(new CustomEvent('pricing:changed', { detail: format }));
}

function initPricingFormat() {
  const cookie = getCookie('pricingFormat');
  if (cookie) {
    setPricingFormat(cookie);
    return;
  }

  if (Shopify.designMode) {
    // No popup in the editor — just apply the default so components render.
    window.pricingFormat = window.VAT_CONFIG.defaultPricing;
    return;
  }

  if (window.VAT_CONFIG.displayPopup) {
    document.querySelector('.vat-selector-popup')?.style.setProperty('display', 'block');
  } else {
    setPricingFormat(window.VAT_CONFIG.defaultPricing);
  }
}

// ── Popup ─────────────────────────────────────────────────────────────────────

document.querySelectorAll('.vat-selector-popup [data-vat-type]').forEach(btn => {
  btn.addEventListener('click', () => setPricingFormat(btn.dataset.vatType));
});

document.querySelector('.vat-selector-popup .close-btn')?.addEventListener('click', () => {
  setPricingFormat(getCookie('pricingFormat') ?? window.VAT_CONFIG.defaultPricing);
});

// ── Inline selectors ──────────────────────────────────────────────────────────

function buildInlineSelectors() {
  const t = getTranslations();
  document.querySelectorAll('.vat-selector-inline').forEach(el => {
    if (el.querySelector('.vat-selector-option')) return;
    el.innerHTML = `
      <div class="vat-selector-option">
        <div class="left-content" data-vat-type="b2b">${t.b2bButton}</div>
        <span>|</span>
        <div class="right-content" data-vat-type="b2c">${t.b2cButton}</div>
      </div>
    `;
    el.querySelectorAll('[data-vat-type]').forEach(btn => {
      btn.addEventListener('click', () => setPricingFormat(btn.dataset.vatType));
    });
  });
}

window.addEventListener('pricing:changed', (e) => {
  const type = e.detail;
  document.querySelectorAll('.vat-selector-option').forEach(opt => {
    opt.querySelector('.left-content')?.classList.toggle('active', type === 'b2b');
    opt.querySelector('.right-content')?.classList.toggle('active', type === 'b2c');
  });
});

// ── Web component ─────────────────────────────────────────────────────────────

class VatSelector extends HTMLElement {
  connectedCallback() {
    window.addEventListener('pricing:changed', this.#onPricingChanged);
    document.addEventListener('cart:finished:updating', this.#onCartFinished);
    document.addEventListener('section:rendered', this.#onCartFinished);
    this.addEventListener('click', this.#onClick);
    this.#render(window.pricingFormat);
  }

  disconnectedCallback() {
    window.removeEventListener('pricing:changed', this.#onPricingChanged);
    document.removeEventListener('cart:finished:updating', this.#onCartFinished);
    document.removeEventListener('section:rendered', this.#onCartFinished);
  }

  #onPricingChanged = (e) => this.#render(e.detail);
  #onCartFinished = () => this.#render(window.pricingFormat);

  #onClick = (e) => {
    e.stopPropagation();
    if (window.pricingFormat) {
      setPricingFormat(window.pricingFormat === 'b2b' ? 'b2c' : 'b2b');
    }
  };

  #render(format) {
    if (!format) return;
    const t     = getTranslations();
    const isB2b = format === 'b2b';
    this.innerHTML = `<span class="vat-price-helper">${isB2b ? ICON_B2B : ICON_B2C} ${isB2b ? t.b2bHelper : t.b2cHelper}</span>`;
  }
}

// Init pricing format before defining components so that window.pricingFormat
// is already set when connectedCallback fires for existing elements.
buildInlineSelectors();
initPricingFormat();

customElements.define('vat-selector', VatSelector);
